import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiOption = (_param)=>{
    var { biData, innerRef, stopPropagation } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    // _value is used in useBiClickLogger to compare with
    //  the parent select's value and recognize a change
    // so add it automatically if it's not there
    if (biData && props.value) {
        biData._value = biData._value || props.value.toString();
    }
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("option", _object_spread_props(_object_spread({}, props), {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiOption.displayName = 'BiOption';
export default BiOption;

//# sourceMappingURL=BiOption.js.map